export const addPaddingsForParagraphs = (html) => {
    return html.replace(
        `</head>`,
        `<style>p { padding-bottom: 10px }</style></head>`
    );
};
